import type {
  Retailer,
  LoggedInRetailer,
} from "@faire/web-api/indigofair/settings/Serialized";
import { createSettingsContextProvider } from "@faire/web/common/settings/hooks/createSettingsContextProvider";

export const { useSetting, useAssignSetting, SettingsContextProvider } =
  createSettingsContextProvider<
    Retailer | LoggedInRetailer,
    "RETAILER" | "LOGGED_IN_RETAILER"
  >();
